import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
	id: '',
	deleteList: [],
	checkedList: [],
	showdetails: false,
};

const tcAdminSlice = createSlice({
	name: 'trainingCenterAdminDetail',
	initialState,
	reducers: {
		tcAdminID: (state, action) => {
			state.id = action.payload;
			console.log('settrainingCenterID', state.id);
		},
		showtcAdminDetails: (state, action) => {
			console.log('Cake Action :', action);
			state.showdetails = action.payload;
		},
		setdeleteList: (state, action) => {
			state.deleteList = [...state.deleteList, action.payload];
		},
		setemptyDeleteList: (state) => {
			state.deleteList = [];
		},
		setfliterDeleteList: (state, action) => {
			state.deleteList = action.payload;
		},
		setcheckedList: (state, action) => {
			// console.log('reduxAction', action.payload);
			state.checkedList = [...state.checkedList, action.payload];
			// console.log('payloadSet', state.checkedList);
		},
		setemptycheckedList: (state, action) => {
			state.checkedList = [];
		},
		setflitercheckedList: (state, action) => {
			state.checkedList = action.payload;
		},
	},
});

export const {
	tcAdminID,
	showtcAdminDetails,
	setdeleteList,
	setcheckedList,
	setemptyDeleteList,
	setfliterDeleteList,
	setflitercheckedList,
	setemptycheckedList,
} = tcAdminSlice.actions;

export const tcAdminReducer = {
	// studentID: studentID.reducer,
	showtcAdminDetails: tcAdminSlice.reducer,
};
